import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckSquare, FileText, Shield, Users, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const Compliance = () => {
  const navigate = useNavigate();
  const complianceServices = [{
    icon: FileText,
    title: 'HACCP Plan Development',
    description: 'Expert development of comprehensive HACCP plans tailored to your specific operations and regulatory requirements.'
  }, {
    icon: Shield,
    title: 'Audit Preparation',
    description: 'Complete audit readiness with documentation review, mock audits, and corrective action planning.'
  }, {
    icon: CheckSquare,
    title: 'Regulatory Updates',
    description: 'Stay current with evolving food safety regulations and ensure ongoing compliance across all jurisdictions.'
  }, {
    icon: Users,
    title: 'Best Practice Recommendations',
    description: 'Industry expertise and recommendations based on latest food safety science and regulatory trends.'
  }];
  const standards = ['HACCP principles and guidelines', 'EU Regulation 852/2004 on food hygiene', 'Forskrift om internkontroll (Norway)', 'UK Food Hygiene Rating Scheme (FHRS)', 'FDA Food Safety Modernization Act (FSMA)', 'Codex Alimentarius general hygiene principles'];
  return <div className="min-h-screen">
      <header className="glass-panel-nav">
        <div className="container mx-auto px-4 py-4">
          <Button variant="glass" onClick={() => navigate('/')} className="mb-4 flex items-center gap-2">
            <ArrowLeft className="h-4 w-4" />
            Back to Home
          </Button>
          <div className="flex items-center gap-4 mb-4">
            <div className="p-3 rounded-xl bg-crystal-orange/10 border border-crystal-orange/20">
              <CheckSquare className="h-8 w-8 text-crystal-orange" />
            </div>
            <div>
              <h1 className="heading-hero py-[6px]">Compliance Consulting</h1>
              <p className="subheading mt-2">
                Expert guidance on food safety regulations and best practices
              </p>
            </div>
          </div>
        </div>
      </header>

      <main className="py-16">
        <div className="container mx-auto px-4">
          {/* Services */}
          <section className="mb-16">
            <h2 className="heading-section mb-8 text-center">Compliance Services</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {complianceServices.map((service, index) => {
              const IconComponent = service.icon;
              return <Card key={service.title} className="glass-panel border-0 bg-transparent">
                    <CardHeader>
                      <div className="flex items-center gap-4 mb-4">
                        <div className="p-3 rounded-xl bg-crystal-orange/10 border border-crystal-orange/20">
                          <IconComponent className="h-6 w-6 text-crystal-orange" />
                        </div>
                        <CardTitle className="text-white">{service.title}</CardTitle>
                      </div>
                    </CardHeader>
                    <CardContent>
                      <p className="text-white/70">{service.description}</p>
                    </CardContent>
                  </Card>;
            })}
            </div>
          </section>

          {/* Standards referenced */}
          <section className="mb-16">
            <div className="glass-panel-elevated p-8">
              <h2 className="heading-section mb-3 text-center">Regulations we build around</h2>
              <p className="text-white/70 text-center mb-8 max-w-2xl mx-auto">
                These are the frameworks the product's record-keeping is designed against. Crystal HACCP is software and holds no certification of its own.
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {standards.map((standard, index) => <div key={index} className="glass-panel p-4 text-center">
                    <p className="text-white font-medium">{standard}</p>
                  </div>)}
              </div>
            </div>
          </section>

          {/* CTA */}
          <section className="text-center">
            <div className="glass-panel-elevated p-8">
              <h3 className="text-2xl font-bold text-white mb-4">
                Ensure Regulatory Compliance with Expert Guidance
              </h3>
              <p className="text-white/70 mb-6 max-w-2xl mx-auto">
                Let our compliance experts help you navigate complex regulations and maintain the highest food safety standards.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button className="cta-primary px-8 py-3">
                  Consult with Expert
                </Button>
                <Button className="cta-secondary px-8 py-3">
                  Download Compliance Guide
                </Button>
              </div>
            </div>
          </section>
        </div>
      </main>
    </div>;
};
export default Compliance;